module.exports = __webpack_public_path__ + "static/media/gallery18.224899f8.png";